import React, { useState, useEffect, useContext, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Map, Popup } from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";
import { LangContext } from "../../Context/Langcontext";
import { Button } from "@material-ui/core";
import { FaPlus, FaMinus } from "react-icons/fa";

const useStyles = makeStyles(() => ({
  zoom: {
    position: "absolute",
    zIndex: 10,
    right: "1%",
    bottom: "22%",
    backgroundColor: "#f2b450eb",
    color: "#faf7f1",
    minWidth: 35,
    height: 35,
  },
  zoomout: {
    position: "absolute",
    zIndex: 10,
    right: "1%",
    bottom: "12%",
    backgroundColor: "#f2b450eb",
    color: "#faf7f1",
    minWidth: 35,
    height: 35,
  },
}));

const MapContainer = ({ style, children }) => {
  const classes = useStyles();
  const refMap = useRef(null);
  const [map, setmap] = useState(undefined);
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;

  useEffect(() => {
    const map = new Map({
      container: refMap.current,
      style: process.env.REACT_APP_MEA_TILE,
      center: [100.554894, 13.721237],
      zoom: 16,
    });

    map.scrollZoom.disable();
    map.on("load", function () {
      map.loadImage(
        "https://upload.i-bitz.co.th/files/2020/06/11/478522ca6c884d01ebc5545a.png",
        function (error, image) {
          if (error) throw error;
          map.addImage("mea_marker", image);
          map.addLayer({
            id: "points",
            type: "symbol",
            source: {
              type: "geojson",
              data: {
                type: "FeatureCollection",
                features: [
                  {
                    type: "Feature",
                    geometry: {
                      type: "Point",
                      coordinates: [100.554894, 13.721237],
                    },
                  },
                ],
              },
            },
            layout: {
              "icon-image": "mea_marker",
              "icon-size": 0.035,
            },
          });
          map.on("click", "points", function (e) {
            new Popup().setLngLat(e.lngLat).setHTML(lang.MEA).addTo(map);
          });

          // Change the cursor to a pointer when the mouse is over the states layer.
          map.on("mouseenter", "points", function () {
            map.getCanvas().style.cursor = "pointer";
          });

          // Change it back to a pointer when it leaves.
          map.on("mouseleave", "points", function () {
            map.getCanvas().style.cursor = "";
          });
        }
      );
      setmap(map);
    });

    return () => {
      map.remove();
      setmap(undefined);
    };
  }, []);

  return (
    <div ref={refMap} className={style}>
      <Button
        className={classes.zoom}
        size="small"
        onClick={() => {
          map.zoomIn();
        }}
      >
        <FaPlus />
      </Button>
      <Button
        className={classes.zoomout}
        size="small"
        onClick={() => {
          map.zoomOut();
        }}
      >
        <FaMinus />
      </Button>
      {children}
    </div>
  );
};

export default MapContainer;
